import React from 'react';
import { atom as stateSegment } from 'jotai';
import { atomWithReset as stateSegmentWithReset } from 'jotai/utils';

import {
  ArrowPosition,
  PopoverVariant,
} from '../../../components/atoms/Popover';
import { QcReviewName } from '../../../types/QualityChecks';

type PopoverState = {
  showPopover: boolean;
  variant: PopoverVariant;
  arrowPosition: ArrowPosition;
  title: string;
  description: string;
  buttonLabel?: string;
  onButtonClick?: () => void;
  showCloseButton?: boolean;
  showIcon?: boolean;
  customIcon?: React.ReactNode;
  qualityChecksStatus?: QcReviewName;
};

export const popoverStateSegment = stateSegmentWithReset<PopoverState>({
  showPopover: false,
  variant: PopoverVariant.DEFAULT,
  arrowPosition: ArrowPosition.TOP_CENTER,
  title: '',
  description: '',
  showCloseButton: true,
  showIcon: true,
  customIcon: null,
  qualityChecksStatus: '' as QcReviewName,
});

export const closePopoverStateSegment = stateSegment(null, (get, set) => {
  set(popoverStateSegment, { ...get(popoverStateSegment), showPopover: false });
});

export const openPopoverStateSegment = stateSegment(null, (get, set) => {
  set(popoverStateSegment, { ...get(popoverStateSegment), showPopover: true });
});

popoverStateSegment.debugLabel = 'popoverStateSegment';
